<template>
  <div>
    <el-card>
      <el-form :inline="true">
        <el-form-item label="状态">
          <el-select v-model="config.refreshStatus" placeholder="请选择">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="刷新时间">
          <el-select v-model="config.refreshType" placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-tag type="danger">天:每日0点 月:每月1号0点</el-tag>
        </el-form-item>

        <el-form-item>
          <el-button v-permisaction="['config:firstPurchasv2:refresh']" type="primary" @click="updateCfg">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getFirstPayRefreshCfg, updateFirstPayRefresh } from '@/api/config/shop-cfg'

export default {
  name: 'RefreshTime',
  data() {
    return {
      types: [{ label: '天', value: 0 }, { label: '月', value: 1 }],
      status: [{ label: '关闭', value: 0 }, { label: '开启', value: 1 }],
      config: {
        refreshType: 0,
        refreshStatus: 0
      }
    }
  },
  created() {
    this.getCfg()
  },
  methods: {
    getCfg() {
      getFirstPayRefreshCfg().then(res => {
        if (res.data !== null && res.data) {
          this.config = res.data
          this.config.refreshType = parseInt(this.config.refreshType)
          this.config.refreshStatus = parseInt(this.config.refreshStatus)
        }
      })
    },
    updateCfg() {
      const data = JSON.stringify(this.config)
      updateFirstPayRefresh({ data: data }).then(res => {
        if (res.code === 200) {
          this.getCfg()
          this.msgSuccess('更新成功')
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
